export default __webpack_public_path__ + "static/media/V730MANB4.4fb46c85.pdf";